import React from 'react';
import { Select, MenuItem } from '@mui/material';

const EVENT_TYPE_IDS = [1, 2, 3];

export const getEventTypeFilterOperators = (translate) => {
  const t = translate || ((k, opts) => opts?._ || k);
  return [
    {
      label: t('filters.equals', { _: 'Equals' }),
      value: 'equals',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) {
          return null;
        }
        return (params) => Number(params.row?.type ?? params.value) === Number(filterItem.value);
      },
      InputComponent: (props) => (
        <Select
          variant="outlined"
          size="small"
          value={props.item.value || ''}
          onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
          displayEmpty
          style={{ width: '100%' }}
        >
          <MenuItem value="" disabled>
            {t('filters.select_type', { _: 'Select type' })}
          </MenuItem>
          {EVENT_TYPE_IDS.map((id) => (
            <MenuItem key={id} value={id}>
              {t(`event_types.${id}`, { _: String(id) })}
            </MenuItem>
          ))}
        </Select>
      ),
    },
  ];
};

const eventTypeFilterOperators = getEventTypeFilterOperators((k, opts) => opts?._ || k);

export default eventTypeFilterOperators;
